import { http } from "./http";

export type CreateInStoreReviewCodePayload = {
  productId: string;
  customerName?: string;
  customerEmail?: string;
  expiresAt?: string;
  notes?: string;
};

export type InStoreReviewCodeResponse = {
  id: string;
  productId: string;
  code: string;
  customerName?: string;
  customerEmail?: string;
  notes?: string;
  expiresAt?: string;
  active: boolean;
  createdAt?: string;
};

export type ReviewModerationStatus = "pending" | "approved" | "rejected";

export type AdminReview = {
  id: string;
  productId: string;
  productName?: string;
  productSlug?: string;
  reviewerName: string;
  reviewerEmail?: string;
  rating: number;
  title?: string;
  comment: string;
  photos?: string[];
  source: "delivery_order" | "in_store" | string;
  verifiedPurchase: boolean;
  moderationStatus: ReviewModerationStatus | string;
  moderationFlags?: string[];
  moderationNotes?: string;
  isPublished: boolean;
  orderNumber?: string;
  reviewRewardCouponCode?: string;
  reviewRewardSentAt?: string;
  reviewRewardType?: string;
  reviewRewardValue?: number;
  reviewRewardApplicableProductIds?: string[];
  createdAt?: string;
  moderatedAt?: string;
  moderatedByAdminId?: string;
};

export type AdminReviewListResponse = {
  items: AdminReview[];
  page: number;
  limit: number;
  total: number;
  pages: number;
};

export const ReviewsAPI = {
  async createInStoreCode(payload: CreateInStoreReviewCodePayload) {
    const r = await http.post<InStoreReviewCodeResponse>(
      "/reviews/in-store-codes",
      payload
    );
    return r.data;
  },

  async listAdmin(params?: {
    page?: number;
    limit?: number;
    status?: ReviewModerationStatus | "";
    productId?: string;
    q?: string;
  }) {
    const r = await http.get<AdminReviewListResponse>("/reviews/admin", { params });
    return r.data;
  },

  async moderate(
    reviewId: string,
    payload: {
      action: "approve" | "reject";
      notes?: string;
      reviewReward?: {
        enabled?: boolean;
        discountType?: "percentage" | "fixed";
        discountValue?: number;
        allProducts?: boolean;
        applicableProductIds?: string[];
      };
    }
  ) {
    const r = await http.patch<{ item: AdminReview; message?: string }>(
      `/reviews/admin/${encodeURIComponent(reviewId)}/moderation`,
      payload
    );
    return r.data;
  },
};
